var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlightCatalog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.399,
    height: 48.42,
    viewBox: "0 0 48.399 48.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575",
    transform: "translate(-42.71 -498.58)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    width: 48.399,
    height: 48.42,
    rx: 13,
    transform: "translate(42.71 498.58)",
    fill: "#80d3b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_fa-regular-paper-plane",
    "data-name": "Icon fa-regular-paper-plane",
    d: "M1.022,16.476A2.042,2.042,0,0,0,1.25,20.1l8.884,3.7v6.541a2.068,2.068,0,0,0,3.66,1.323l3.926-4.7,7.845,3.267a2.044,2.044,0,0,0,2.78-1.564L32.4,2.33A2.025,2.025,0,0,0,29.389.266L1.022,16.476Zm3.3,1.615L25.945,5.737,12.039,21.276l.076.063Zm21.219,8.846-10.549-4.4L28.547,7.383,25.539,26.936Z",
    transform: "translate(49.688 507.58)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightCatalog);
export default __webpack_public_path__ + "static/media/flight_catalog.22eccb5ff5de537174dbe1d44efbab1f.svg";
export { ForwardRef as ReactComponent };